import { genVr } from "../../core/utils";
import { BaseEntity, EntityIndex, ModelEntity, ParentEntity, ShortFieldType } from "../../core/baseEntity.model";
import { AuthService } from "../core-services/auth.service";
import { PaymentPropagateTrait } from "../payment/payment.entity";
import { AccountService } from "../account/account.service";

export enum AppointmentStatus {
    pending = 'pending',
    confirmed = 'confirmed',
    cancelled = 'cancelled',
    completed = 'completed'
}

export enum PaymentStatus {
    pending = 'pending',
    paid = 'paid',
    cancelled = 'cancelled',
}
export interface AppointmentTrait {
    id: string;
    title?: string;
    startTime: number;
    endTime: number;
    clientId: string;
    clientName: string;
    createdAt: number;
    status?: AppointmentStatus;
    paymentStatus?: PaymentStatus;
    price: number;
    dueDate?: number;
    payments?: PaymentPropagateTrait[];
    paidAmount?: number;
    generateInvoice?: boolean;
    independent?: boolean;
}

@ModelEntity("appointments")
export class AppointmentEntity extends BaseEntity<AppointmentEntity> implements AppointmentTrait {
    @ParentEntity("users", () => AuthService.instance.currentUser?.uid)
    public userId: string;

    public dueDate: number;

    // public payments: PaymentPropagateTrait[];

    // public paidAmount: number = 0;
    public independent: boolean;
    public set paidAmount(v) {}

    public get paidAmount(): number {
        let paid = 0;
        
        for (const payment of Array.from(this.payments || [])) {
            for (const appointment of Array.from(payment.invoices || [])) {
                if (this.id == appointment.id) {
                    paid += appointment.paidAmount;
                }
            }
        }
        return paid;
    }

    public get pendingAmount(): number {
        return (this.price || AccountService.instance?.account.settings.appointmentPrice || 0) - this.paidAmount;
    }

    public clientName: string;
    generateInvoice?: boolean;
    constructor(
        public id: string,
        public startTime: number,
        public endTime: number,
        public clientId: string,
        public title: string,
        public price: number,
        public createdAt: number = Date.now(),
        public status: AppointmentStatus = AppointmentStatus.pending,
        public paymentStatus: PaymentStatus = PaymentStatus.pending,
        public payments: PaymentPropagateTrait[] = [],
        public version: string = genVr()
    ) {
        super();
        // this.paidAmount = this._paidAmount;
        let paid = 0;

        for (const payment of Array.from(this.payments || [])) {
            for (const appointment of Array.from(payment.invoices || [])) {
                if (this.id == appointment.id) {
        
                    paid += appointment.paidAmount;
                }
            }
        }
    }

    static async loadAll<C extends BaseEntity<C>>(id: string = AuthService.instance?.currentUser?.uid, {parentName, offset, ignoreStorageDbData, orderBy}: {parentName?: string; offset?: string; ignoreStorageDbData?: boolean; orderBy?: {
        column: keyof C;
        sort: 'asc' | 'desc'
    }} = {parentName: 'users'}): Promise<C[]> {
        super.setParent('users', id);
        return super.loadAll(id, {parentName: parentName || 'users', offset, orderBy, ignoreStorageDbData: ignoreStorageDbData || true});
    }

    static async persistMany<T = AppointmentEntity>(data: T[]): Promise<boolean> {
        const id = AuthService.instance?.currentUser?.uid;
        super.setParent('users', id);
        return super.persistMany<T>(data, id)
    }  
    public export<T = AppointmentTrait>(): T {

        return {
            id: this.id,
            version: this.version,
            startTime: this.startTime,
            title: this.title,
            endTime: this.endTime,
            clientId: this.clientId,
            clientName: this.clientName,
            createdAt: this.createdAt,
            status: this.status || AppointmentStatus.pending,
            paymentStatus: this.paymentStatus || PaymentStatus.pending,
            payments: this.payments,
            paidAmount: this.paidAmount || this.payments?.reduce((acc, payment) => acc + payment.amount, 0) || 0,
            dueDate: this.dueDate,
            price: +this.price,
            generateInvoice: this.generateInvoice,
        } as any;
    }

    public async postLoad(): Promise<this> {
        const payments = {};
        if (this.payments?.length > 0) {
            for (const payment of this.payments) {
                payments[payment.id] = !payments[payment.id] || payments[payment.id].version < payment.version ? payment : payments[payment.id];
            }
            this.payments = Object.values(payments);
        }

        return this;
    }

    static shortFields() {
        return {
            id: 'id',
            tt: 'title',
            st: 'startTime',
            et: 'endTime',
            sts: 'status',
            cid: 'clientId',
            pc: 'price',
            dd: 'dueDate',
            pa: 'paidAmount',
            ps: 'paymentStatus',
            pms: 'payments',
            ca: 'createdAt',
            cn: 'clientName',
            ua: 'updatedAt',
            gi: 'generateInvoice',
        }
    }
    
}


export interface AppointmentReducedBaseTrait {
    id: string;
    tt: string;
    st: number;
    et: number;
    sts: AppointmentStatus;
    gi: boolean;
}

export interface AppointmentFullReducedTrait extends AppointmentReducedTrait {
    cid: string;
    cn: string;
    pc: number;
    dd: number;
    pa: number;
}

export interface AppointmentReducedTrait extends AppointmentReducedBaseTrait {
    ps: PaymentStatus;
}

export interface AppointmentReducedPendingTrait extends AppointmentReducedBaseTrait {
    pc: number;
    dd: number;
    pa: number;
}

export interface AppointmentReducedCloseDueTrait extends AppointmentReducedBaseTrait {
    pc: number;
    dd: number;
    pa: number;
}